import React from "react";
import styles from "../css/Yuyue.css";
import { Toast, ActivityIndicator } from "antd-mobile";
import { request, origin } from "../request";
import { Header } from "./Introduce";
import { checkToekn, Img } from "../tools/wechatBrower";

export const Item = ({
  left,
  rightP,
  value,
  id,
  disabled = false,
  onChange = (e) => { },
}) => {
  return (
    <div className={styles.item}>
      <span className={styles.itemLeft}>{left}</span>
      <input
        type="text"
        placeholder={rightP}
        className={styles.itemRight}
        value={value}
        disabled={value && disabled ? true : false}
        onChange={(e) => {
          onChange(e.target.value);
        }}
        id={id}
      ></input>
    </div>
  );
};

const TextArea = ({ left, placeholder, render, id, value }) => {
  return (
    <div className={styles.textarea}>
      <div className={styles.leftItem}>
        <span className={styles.textareaTitle}>{left}</span>
        {render ? render() : null}
      </div>
      <textarea
        placeholder={placeholder}
        className={styles.textareaContent}
        id={id}
        value={value}
        disabled
      ></textarea>
    </div>
  );
};

export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      info: {},
      isuploading: true,
      display: false, // 禁止修改  当查看详情时 true  创建修改 false
      cctj: "",
      jggs: "",
      fplx: "",
      attach: "",
      topic_source: "",
      yphs: "0",
      pay_method: "",
      pay_name: "",
      pay_id: "",
      data: {
        ypjz: "",
      },
      invoice_id: "",
      receiving_information_id: "",
      recipient_list: [],
      uploaedImages: [],
      fp_list: [],
      sj_list: [],
      ketilaiyuan: false,
      cunchu: false,
      jieguo: false,
      info_status: 0,
    };
  }

  /**
   * 用户信息
   * @returns
   */
  info() {
    return (
      <div className={styles.info}>
        <div className={styles.head}>
          <span className={styles.title}>个人信息</span>
          {/* <span className={styles.des}>该信息自动在个人中心中填充</span> */}
        </div>
        <Item
          left="姓名"
          rightP="请输入姓名"
          id="name"
          value={this.state.data.name}
          disabled={true}
        ></Item>
        <Item
          left="手机号"
          rightP="请输入手机号"
          id="phone"
          value={this.state.data.phone}
          disabled={true}
        ></Item>
        <Item
          left="电子邮箱"
          rightP="请输入电子邮箱"
          id="email"
          value={this.state.data.email}
          disabled={true}
        ></Item>
        <Item
          left="所在单位"
          rightP="请输入所在单位"
          id="company_name"
          value={this.state.data.company_name}
          disabled={true}
        ></Item>
      </div>
    );
  }

  componentDidMount() {
    checkToekn();

    if (this.props.match.params.id) {
      request(
        "index/getOrder",
        {
          uid: localStorage.getItem("openid"),
          id: this.props.match.params.id,
        },
        ({ data }) => {
          if (data.code === 1) {
            this.setState(
              {
                display: true,
                data: data.data,
              },
              () => {
                this.setId(
                  "test_requirements",
                  this.state.data.test_requirements
                );
                this.setId("ypjz", this.state.data.ypjz);
                this.setId("dcshl", this.state.data.dcshl);
                this.setId("dcshl", this.state.data.dcshl);
                this.setId("ypxz", this.state.data.ypxz);
                this.setId("ffck", this.state.data.ffck);
                this.setId("remark", this.state.data.remark);

                // this.setId("pay_method", this.state.data.pay_method);
                // this.setId("pay_id", this.state.data.pay_id);
                // this.setId("pay_name", this.state.data.pay_name);

                if (data.data.attachfiles) {
                  data.data.attachfiles.split(",").forEach((attachfile) => {
                    let filename = attachfile.split("_")[2];
                    let each = {
                      url: attachfile,
                      filename: filename,
                    };
                    this.state.uploaedImages.push(each);
                  });
                }
              }
            );
          } else {
            Toast.info("获取订单失败");
          }
        }
      );
    } else {
    }

    setTimeout(() => {
      this.setState({
        isuploading: false,
      });
    }, 500);
  }

  getRecipientLIst() {
    request(
      "index/getReceiving",
      {
        uid: localStorage.getItem("openid"),
      },
      ({ data }) => {
        if (data.code === 1) {
          let use_recipient_list = data.data.info.map((item) => {
            let each = {};
            each.tag = item.tag;
            each.id = item.id;
            return each;
          });
          this.setState({
            recipient_list: use_recipient_list,
          });
        }
      }
    );
  }

  getFpList() {
    request(
      "index/getInvoice",
      {
        uid: localStorage.getItem("openid"),
      },
      ({ data }) => {
        if (data.code === 1) {
          console.log(data.data.info);
          if (data.data.info) {
            let use_fp_list = data.data.info.map((item) => {
              item.label = item.company_name + "-" + item.type;
              item.value = item.id;
              return item;
            });
            this.setState(
              {
                fp_list: use_fp_list,
              },
              () => {
                console.log(this.state.fp_list);
              }
            );
          }
        }
      }
    );
  }

  // 收件信息展示
  sjxx() {
    console.log(this.state.recipient_list, "this.state.recipient_list");

    console.log("this.state.yphs", this.state.yphs);
    return (
      this.state.yphs === 1 &&
      (this.state.recipient_list.length === 0 ? (
        <div
          style={{
            color: "#999999",
            fontSize: "0.7rem",
            textAlign: "center",
            margin: "10px 0",
          }}
        >
          请到个人中心页面去添加
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            // display: !this.state.ketilaiyuan && "none",
          }}
          onChange={(e) => {
            this.receiving_information_id(e);
          }}
        >
          {this.state.recipient_list.map((item, index) => (
            <label key={index} className={styles.font}>
              <input name="yphs2" type="radio" value={item.id} />
              {item.tag}
            </label>
          ))}
        </div>
      ))
    );
  }

  getId(name) {
    console.log(name);
    return document.getElementById(name).value;
  }

  getBuyName(name) {
    let inputs = document.getElementsByName(name);
    let checd = [];
    for (let index = 0; index < inputs.length; index++) {
      if (inputs[index].checked) {
        checd.push(inputs[index]);
      }
    }

    return checd[0].attributes.value.value;
  }

  setItem(name) {
    if (this.getId(name)) {
      localStorage.setItem(name, this.getId(name));
    }
  }

  setId(name, value) {
    document.getElementById(name).value = value;
  }

  _setState(name) {
    if (localStorage.getItem(name)) {
      switch (name) {
        case "topic_source":
          this.setState({
            topic_source: localStorage.getItem(name),
          });
          break;
        case "cctj":
          this.setState({
            cctj: localStorage.getItem(name),
          });
          break;
        case "jggs":
          this.setState({
            jggs: localStorage.getItem(name),
          });
          break;
        case "ypjs":
          this.setState({
            ypjs: localStorage.getItem(name),
          });
          break;
        case "fplx":
          this.setState({
            fplx: localStorage.getItem(name),
          });
          break;

        default:
          break;
      }
    }
  }

  yphs(e) {
    console.log("e.target.value", e.target.value, typeof e.target.value);
    let value = e.target.value;

    this.setState({
      yphs: value,
    });
  }

  fp_school(e) {
    console.log("e.target.value", e.target.value, typeof e.target.value);
    let value = e.target.value;

    this.setState({
      fp_school: value,
    });
  }

  topic_source(e) {
    // eslint-disable-next-line
    this.state.topic_source = e.target.value;
  }

  cctj(e) {
    console.log(e.target.value, "this.state.cctj");
    // eslint-disable-next-line
    this.state.cctj = e.target.value;
  }

  jggs(e) {
    // eslint-disable-next-line
    this.state.jggs = e.target.value;
  }

  ypjs(e) {
    this.setState({
      ypjs: e.target.value,
    });
  }

  fplx(e) {
    // eslint-disable-next-line
    this.state.fplx = e.target.value;
  }

  
  

  FP() {
    return this.state.fp_school === "校外" &&
      this.state.fp_list.length === 0 ? (
      <div>
        <div
          style={{
            color: "#999999",
            fontSize: "0.7rem",
            textAlign: "center",
            margin: "10px 0",
          }}
        >
          请到个人中心页面去添加
        </div>
      </div>
    ) : (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          // display: !this.state.ketilaiyuan && "none",
        }}
        onChange={(e) => {
          this.fp(e);
        }}
      >
        {this.state.fp_list.map((item, index) => (
          <label key={index} className={styles.font} style={{marginRight:'8px'}}>
            <input name="fp" type="radio" value={item.id} />
            {item.label}
          </label>
        ))}
      </div>
    );
  }

  fp(e) {
    console.log(e.target.value, "e.target.value");
    this.state.invoice_id = e.target.value;
  }

  receiving_information_id(e) {
    this.state.receiving_information_id = e.target.value;
  }

  /**
   * 课题信息
   * @returns
   */
  subject_information() {
    return (
      <div className={styles.info}>
        <div className={styles.head}>
          <span className={styles.title}>课题信息</span>
        </div>
        <Item
          left="* 课题负责人"
          id="topic_leader"
          value={this.state.data ? this.state.data.topic_leader : ""}
          disabled={true}
        ></Item>
        <Item
          left="* 课题名称"
          id="topic_name"
          value={this.state.data ? this.state.data.topic_name : ""}
          disabled={true}
        ></Item>
        <Item
          left="* 课题来源"
          id="topic_name"
          value={this.state.data ? this.state.data.topic_source : ""}
          disabled={true}
        ></Item>
      </div>
    );
  }

  /**
   * 样品信息
   * @returns
   */
  sample() {
    return (
      <div className={styles.info}>
        <div className={styles.head}>
          <span className={styles.title}>样品信息</span>
          <span className={styles.des}>
            请务必提前查看相关仪器的
            {/* <a href="#/test_know" style={{color: 'rgb(174, 92, 201)'}}>送检须知</a> */}
            <span
              onClick={() => {
                this.props.history.push("/test_know");
                // showAlert({
                //   content:
                //   (
                //   <div>
                //     <div>
                //       本次送检信息可暂存在“服务单”列表中，有效期7天，是否暂存？
                //     </div>
                //     <div>返回后请到“个人中心”“服务单”继续填写！</div>
                //   </div>
                // ),
                //   cancelFunc: () => {
                //     this.props.history.push("/test_know");
                //   },
                //   enterFunc: () => {
                //     this.__zancun();
                //     this.props.history.push("/test_know");
                //   },
                // });
              }}
              style={{ color: "rgb(174, 92, 201)" }}
            >
              送检须知
            </span>
          </span>
        </div>
        <TextArea
          id="test_requirements"
          left="* 测试需求"
          value={this.state.data.test_requirements}
        ></TextArea>
        <TextArea
          id="ypjz"
          left="* 样品基质"
          value={this.state.data.ypjz}
        ></TextArea>
        <TextArea
          id="dcshl"
          left="* 目标物含量"
          value={this.state.data.dcshl}
        ></TextArea>
        <TextArea
          id="ypxz"
          left="* 样品性质"
          value={this.state.data.ypxz}
        ></TextArea>
        <TextArea
          id="ffck"
          left="* 方法参考与建议"
          value={this.state.data.ffck}
        ></TextArea>
        <Item
          left="* 样品数量"
          rightP="请输入样品数量"
          id="ypsl"
          value={this.state.data ? this.state.data.ypsl : ""}
          disabled={true}
        ></Item>

        <Item
          left="* 储存条件"
          id="ypsl"
          value={this.state.data ? this.state.data.cctj : ""}
          disabled={true}
        ></Item>
      </div>
    );
  }

  /**
   * 上传附件
   * @returns
   */
  upload() {
    if (this.state.uploaedImages.length > 0) {
      return (
        <div className={styles.info}>
          <div className={styles.head}>
            <span className={styles.title}>上传附件</span>
            {/* <span className={styles.des}>该处可上传图片、word、PDF文件</span> */}
          </div>

          <div>
            <p
              style={{
                marginTop: "0.3rem",
                lineHeight: "1rem",
                textAlign: "left",
              }}
            >
              该处可通过手机上传拍照或者图片，可通过微信浏览器PC端上传WORD、PDF文件；
            </p>
            <p
              style={{
                marginTop: "0.3rem",
                lineHeight: "1rem",
                textAlign: "left",
              }}
            >
              请上传包含分析方法（颜色标记）的图片、WORD或者PDF文件，每个文件小于10M。
            </p>
          </div>

          <div className={styles.chusedImage}>
            {this.state.uploaedImages.map((item, index) => (
              <Img
                item={item}
                onClick={() => {
                  this.state.uploaedImages.splice(index, 1);
                  this.setState();
                }}
                hide={true}
              ></Img>
            ))}
          </div>
        </div>
      );
    } else {
      return <div></div>;
    }
  }

  /**
   * 其他信息
   * @returns
   */
  other() {
    return (
      <div className={styles.info} style={{ paddingBottom: "1rem" }}>
        <div className={styles.head}>
          <span className={styles.title}>其他信息</span>
          <span className={styles.des}></span>
        </div>

        {/* <Item
          left="* 结果格式"
          id="topic_leader"
          value={this.state.data ? this.state.data.jggs : ""}
          disabled={true}
        ></Item> */}

        <Item
          left="* 送样方式"
          id="topic_leader"
          value={this.state.data ? this.state.data.ypjs : ""}
          disabled={true}
        ></Item>

        {this.state.data.ypjs !== "自主送样" && (
          <div>
            <Item
              left="快递信息"
              id="topic_leader"
              value={this.state.data ? this.state.data.kd : ""}
              disabled={true}
            ></Item>
            <Item
              left="运单号"
              id="topic_leader"
              value={this.state.data ? this.state.data.kddh : ""}
              disabled={true}
            ></Item>
          </div>
        )}

        <Item
          left="* 样品回收"
          value={
            this.state.data ? (this.state.data.yphs === 0 ? "否" : "是") : ""
          }
          disabled={true}
        ></Item>

        {/* <Item
          left="* 发票信息"
          value={this.state.data ? this.state.data.fp_school : ""}
          disabled={true}
        ></Item> */}


        <Item
          left="* 付款方式"
          value={this.state.data ? this.state.data.pay_method : ""}
          disabled={true}
        ></Item>

        {this.state.data.pay_method === "校内平台" && (
          <div>
            <Item
              left="* 主用户姓名"
              value={this.state.data ? this.state.data.pay_name : ""}
              disabled={true}
            ></Item>

            <Item
              left="* 从用户证件号"
              value={this.state.data ? this.state.data.pay_id : ""}
              disabled={true}
            ></Item>
          </div>
        )}

        {this.state.data.pay_method === "中心预存" && (
          <div>
            <Item
              left="* 经费负责人"
              value={this.state.data ? this.state.data.funding_manager : ""}
              disabled={true}
            ></Item>


          </div>
        )}

        {this.state.data.pay_method === "校外发票" && (
          <div>

            <Item
              left="* 发票抬头"
              value={this.state.data ? this.state.data.invoice_company_name : ""}
              disabled={true}
            ></Item>
            <Item
              left="* 发票税号"
              value={this.state.data ? this.state.data.company_id : ""}
              disabled={true}
            ></Item>

          </div>
        )}

        <div className={styles.textarea}>
          <div className={styles.leftItem}>
            <span className={styles.textTitle}>备注</span>
          </div>
          <textarea
            className={styles.textareaContent}
            style={{ height: "57px" }}
            id="remark"
            disabled
          ></textarea>
        </div>
      </div>
    );
  }

  render() {
    // console.log("this.state.fp_list", this.state.fp_list);
    return (
      <form>
        <Header text="我要送检"></Header>
        <div className={styles.main}>
          {this.info()}

          {this.subject_information()}

          {this.sample()}

          {this.upload()}

          {this.other()}

          <ActivityIndicator
            toast
            text="正在加载"
            animating={this.state.isuploading}
          />
        </div>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/SeeOrder.js